import Vue from "vue";
import Vuex from "vuex";
import axios from "axios";
import config from "../config";
import i18n from "../plugins/i18n";
import jwt from "jsonwebtoken";
import localStorageService from "../services/localStorageService";
import avatars from "../services/avatars";
import usersManager from "../apis/users";
import wizards from "../apis/wizard";

Vue.use(Vuex);

let host = window.location.host;

export default new Vuex.Store({
  state: {
    cookiesVisible: true,
    loggingIn: false,
    editing: null,
    editing_step: 0,
    user: {
      gravatar: null,
      first_name: "",
      last_name: "",
      id: 0,
      avatar: "",
      email: "",
      locale: "it",
      roles: "",
      sites_count: 0,
    },
    host: host,

    avatar: null,

    wsteps: [
      {
        name: "Iscrizione",
        state: true,
        index: 1,
        component: () => import("../components/Wizard/step-1"),
      },
      {
        name: "Piano iscrizione",
        state: false,
        index: 2,
        component: () => import("../components/Wizard/step-2"),
      },
      {
        name: "Nome dominio",
        state: false,
        index: 3,
        component: () => import("../components/Wizard/step-3"),
      },
      {
        name: "Aspetto",
        state: false,
        index: 4,
        component: () => import("../components/Wizard/step-4"),
      },
      {
        name: "Lista servizi",
        state: false,
        index: 5,
        component: () => import("../components/Wizard/step-5"),
      },
      {
        name: "Contenuti",
        state: false,
        index: 6,
        component: () => import("../components/Wizard/step-6"),
      },
      {
        name: "Accordo",
        state: false,
        index: 7,
        component: () => import("../components/Wizard/step-7"),
      },
      {
        name: "Finalizza",
        state: false,
        index: 8,
        component: () => import("../components/Wizard/step-8"),
      },
      {
        name: "Pagamento",
        state: false,
        index: 9,
        component: () => import("../components/Wizard/step-9"),
      },
      {
        name: "Completato",
        state: false,
        index: 10,
        component: () => import("../components/Wizard/step-10"),
      },
    ],

    westeps: [
      {
        name: "Aspetto",
        state: false,
        index: 1,
        component: () => import("../components/Wizard/step-4"),
      },
      {
        name: "Lista servizi",
        state: false,
        index: 2,
        component: () => import("../components/Wizard/step-5"),
      },
      {
        name: "Contenuti",
        state: false,
        index: 3,
        component: () => import("../components/Wizard/step-6"),
      },
    ],

    wizard: {},

    isLogged() {
      return this.user.id > 0;
    },

    isAdmin() {
      return false;
    },

    isSuperAdmin() {
      return false;
    },
  },
  mutations: {
    acceptCookies() {
      this.state.cookiesVisible = false;
      localStorageService.setCookie(false);
    },

    refuseCookies() {
      this.state.cookiesVisible = false;
    },

    loginStart: (state) => {
      state.loggingIn = true;
    },

    loginCompleted: (state, payload) => {
      if (payload.access_token && payload.refresh_token && payload.u) {
        localStorageService.setToken({
          access_token: payload.access_token,
          refresh_token: payload.refresh_token,
        });
        localStorageService.setAvatar(payload.avatar);

        state.user = payload.u;
        i18n.locale = state.user.locale;
        state.user.avatar = payload.avatar;
        state.avatar = payload.avatar;
        if (!state.user.locale) state.user.locale = "it";
      } else {
        state.user = {};
        localStorageService.clearToken();
      }
      state.loggingIn = false;
    },

    logoutCompleted: (state) => {
      state.loggingIn = false;
      state.user = {};
      state.wizard = {
        selectedStep: 1,
        completedStep: 0,
        meta: {},
      };
      localStorageService.clearToken();
      localStorageService.setWizardState(null);
    },

    setWizardSteps: (state, payload) => {
      state.wizard.selectedStep = payload.selectedStep;
      if (payload.build_state_id)
        state.wizard.build_state_id = payload.build_state_id;
      state.wizard.meta = { ...state.wizard.meta, ...payload.meta };
      if (payload.completedStep > state.wizard.completedStep)
        state.wizard.completedStep = payload.completedStep;
      localStorageService.setWizardState(state.wizard);
    },

    setEditingMeta: (/*state, payload*/) => {},

    completeWizard: (/*state*/) => {},

    wipeWizard: () => {
      localStorageService.setWizardState(null);
    },
  },
  actions: {
    async initialiseStore() {
      if (config.host == "ebiology") {
        this.state.westeps.push({
          name: "Blog",
          state: false,
          index: 4,
          component: () => import("../components/Wizard/blog"),
          requiredFeature : ['premium','deluxe']
        });
      }

      let localAccessToken = localStorageService.getAccessToken();
      let localAvatar = localStorageService.getAvatar();
      let localGravatar = localStorageService.getGravatar();
      this.state.cookiesVisible = localStorageService.getCookie();

      let localLocale = localStorageService.getLocale();
      if (!localLocale) {
        localLocale = "it";
        i18n.locale = localLocale;
      } else {
        i18n.locale = localLocale;
      }

      if (localAccessToken) {
        let decodedToken = jwt.decode(localAccessToken);
        this.state.user = decodedToken.user;
        this.state.user.avatar = localAvatar;
        this.state.user.locale = localLocale;
        this.state.user.gravatar = localGravatar;
        i18n.locale = localLocale;
      }

      if (!this.state.user) {
        this.state.user = {
          gravatar: null,
          first_name: "",
          last_name: "",
          id: 0,
          avatar: "",
          email: "",
          locale: "it",
          roles: "",
        };
        i18n.locale = localLocale;
      }

      this.state.wizard = localStorageService.getWizardState();
      if (!this.state.wizard.selectedStep)
        this.state.wizard = {
          selectedStep: 1,
          completedStep: 0,
          meta: {},
        };
      else if (
        !this.state.wizard.completedStep ||
        !this.state.wizard.selectedStep
      )
        this.state.wizard = {
          selectedStep: 1,
          completedStep: 0,
          meta: {},
        };
      else if (!this.state.wizard.meta) this.state.wizard.meta = {};

      if (
        (this.state.user.id > 0 && this.state.wizard.selectedStep < 2) ||
        !this.state.wizard.selectedStep
      ) {
        this.state.wizard.selectedStep = 2;
      }

      if (
        this.state.user.id > 0 &&
        (this.state.wizard.completedStep < 1 ||
          !this.state.wizard.completedStep)
      ) {
        this.state.wizard.completedStep = 1;
      }

      if (!this.state.user.id) {
        this.state.wizard.selectedStep = 1;
        this.state.wizard.completedStep = 0;
      } else {
        try {
          const db_wizard_state = await wizards.getWizardState();
          this.state.wizard.build_state_id =
            db_wizard_state.data.responseData.build_state_id;
        } catch (err) {
          this.state.wizard.build_state_id = null;
        }
      }
    },

    login({ commit }, user) {
      return new Promise((resolve, reject) => {
        commit("wipeWizard");
        commit("loginStart");
        axios({
          url: config.apiEndPoint + "/auth/login",
          data: user,
          method: "POST",
        })
          .then((resp) => {
            if (resp.data.responseError) {
              commit("loginCompleted", { error: resp.data.responseError });
              localStorageService.clearToken();
              reject(resp.data.responseError);
            } else {
              let accessToken = resp.data.responseData.authToken;
              let refreshToken = resp.data.responseData.refreshToken;
              let responseUser = resp.data.responseData.user;

              if (!accessToken || !user || !refreshToken) {
                commit("loginCompleted", {});
                localStorageService.clearToken();
                if (resp.data.responseError) reject(resp.data.responseError);
                else reject("Invalid response from server");
              } else {
                if (responseUser.wizard) {
                  commit("setWizardSteps", {
                    completedStep: responseUser.wizard.completedStep,
                    selectedStep: responseUser.wizard.completedStep + 1,
                    meta: responseUser.wizard.meta,
                    build_state_id: responseUser.wizard.build_state_id,
                  });
                } else {
                  commit("setWizardSteps", {
                    completedStep: 1,
                    selectedStep: 2,
                  });
                }

                if (responseUser.gravatar == 1) {
                  avatars
                    .fetchGravatar(responseUser.email)
                    .then((result) => {
                      let responseAvatar = result;

                      commit("loginCompleted", {
                        access_token: accessToken,
                        refresh_token: refreshToken,
                        u: responseUser,
                        avatar: responseAvatar,
                      });
                      resolve(resp);
                    })
                    .catch((err) => {
                      console.log(err);
                      commit("loginCompleted", {
                        access_token: accessToken,
                        refresh_token: refreshToken,
                        u: responseUser,
                        avatar: null,
                      });
                      resolve(resp);
                    });
                } else if (responseUser.gravatar == 0) {
                  // Fetch user profile picture

                  usersManager
                    .fetchAvatar(responseUser.id, accessToken)
                    .then((result) => {
                      this.state.user.avatar = result.avatar;
                      localStorageService.setAvatar(this.state.user.avatar);
                      commit("loginCompleted", {
                        access_token: accessToken,
                        refresh_token: refreshToken,
                        u: responseUser,
                        avatar: this.state.user.avatar,
                      });
                      resolve(resp);
                    })
                    .catch((err) => {
                      console.log(err);
                      commit("loginCompleted", {
                        access_token: accessToken,
                        refresh_token: refreshToken,
                        u: responseUser,
                        avatar: null,
                      });
                      resolve(resp);
                    });
                } else {
                  commit("loginCompleted", {
                    access_token: accessToken,
                    refresh_token: refreshToken,
                    u: responseUser,
                    avatar: null,
                  });
                  resolve(resp);
                }
              }
            }
          })
          .catch((err) => {
            commit("loginCompleted", { error: err });
            localStorageService.clearToken();
            reject(err);
          });
      });
    },

    logout({ commit }) {
      return new Promise((resolve, reject) => {
        axios({
          url: config.apiEndPoint + "/auth/logout",
          data: {},
          method: "POST",
        })
          .then(function() {
            commit("logoutCompleted");
            resolve();
          })
          .catch(function(error) {
            commit("logoutCompleted");
            reject(error);
          });
      });
    },

    unauthorized({ commit }) {
      return new Promise((resolve) => {
        commit("logoutCompleted");
        resolve();
      });
    },

    completeWizard({ commit }, payload) {
      return new Promise((resolve, reject) => {
        wizards
          .completeWizard(payload)
          .then((res) => {
            commit("completeWizard");
            resolve(res);
          })
          .catch((err) => {
            commit("completeWizard");
            reject(err);
          });
      });
    },

    wipeWizard({ commit }) {
      return new Promise((resolve) => {
        commit("wipeWizard");
        resolve();
      });
    },

    setWizardSteps({ commit }, state) {
      return new Promise((resolve, reject) => {
        wizards
          .setWizardSteps(state)
          .then((res) => {
            state.build_state_id = res.data.responseData.build_state_id;
            commit("setWizardSteps", state);
            resolve();
          })
          .catch((err) => {
            commit("setWizardSteps", { completedStep: 0, selectedStep: 1 });
            reject(err);
          });
      });
    },

    setEditingMeta({ commit }, state) {
      return new Promise((resolve, reject) => {
        wizards
          .setEditingMeta(state, this.state.editing)
          .then(() => {
            commit("setEditingMeta", state);
            resolve();
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
  },
  modules: {},
});
